import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

// Direct Stripe payment links (no API config needed)
const STRIPE_PRO_LINK = 'https://buy.stripe.com/bJe14p2EO2gN1ni53f9fW00'
const STRIPE_ELITE_LINK = 'https://buy.stripe.com/9B69AVcfoaNj5Dy8fr9fW01'

const plans = [
  {
    id: 'free',
    name: 'Trial',
    price: '$0',
    period: '14 days',
    description: 'Evaluate the platform',
    features: [
      'Dashboard access',
      'Signal feed (read-only)',
      'Public track record',
    ],
    cta: 'Current Plan',
    link: null,
  },
  {
    id: 'pro',
    name: 'Professional',
    price: '$10',
    period: '/mo',
    description: 'Full platform access',
    featured: true,
    features: [
      'Unlimited deliberations',
      'Full analyst reasoning',
      'Real-time signal feed',
      'Breach intelligence',
      'Watchlist alerts',
    ],
    cta: 'Upgrade',
    link: STRIPE_PRO_LINK,
  },
  {
    id: 'elite',
    name: 'Elite',
    price: '$50',
    period: '/mo',
    description: 'Advanced capabilities',
    features: [
      'Everything in Professional',
      'Custom analyst councils',
      'Model comparison (Titans)',
      'REST API access',
      'Priority processing',
    ],
    cta: 'Upgrade',
    link: STRIPE_ELITE_LINK,
  },
]

export default function Pricing() {
  const { user } = useAuth()
  const navigate = useNavigate()

  const handleUpgrade = (plan) => {
    if (!plan.link) return

    if (!user) {
      // Redirect to register first, then they can upgrade
      navigate('/register')
      return
    }

    if (plan.id === user?.tier) return

    // Direct redirect to Stripe payment link with email prefill
    const url = new URL(plan.link)
    if (user?.email) {
      url.searchParams.set('prefilled_email', user.email)
    }
    window.location.href = url.toString()
  }

  return (
    <div className="pricing-page">
      <div className="pricing-header">
        <h1 className="pricing-title">Access Tiers</h1>
        <p className="pricing-subtitle">
          Institutional intelligence at every scale.
        </p>
      </div>

      <div className="pricing-grid">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`pricing-card ${plan.featured ? 'featured' : ''}`}
          >
            <div className="pricing-tier">{plan.name}</div>
            <div className="pricing-price">
              {plan.price}
              <span>{plan.period}</span>
            </div>
            <p style={{ color: 'var(--text-dim)', marginBottom: '16px' }}>
              {plan.description}
            </p>

            <ul className="pricing-features">
              {plan.features.map((feature, i) => (
                <li key={i}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>

            <button
              className={`btn ${plan.id === 'free' || plan.id === user?.tier ? 'btn-secondary' : 'btn-primary'}`}
              style={{ width: '100%' }}
              disabled={plan.id === 'free' || plan.id === user?.tier}
              onClick={() => handleUpgrade(plan)}
            >
              {plan.id === user?.tier ? 'Current Plan' : plan.cta}
            </button>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '48px' }}>
        <p style={{ color: 'var(--text-dim)', fontSize: '14px' }}>
          Questions? Contact support@alphalens.org
        </p>
        {!user && (
          <p style={{ marginTop: '16px' }}>
            <Link to="/login" style={{ color: 'var(--accent-blue)' }}>
              Already have an account? Sign in
            </Link>
          </p>
        )}
      </div>
    </div>
  )
}
